export const workStationShortName = "ws";
